import JSBI from "jsbi";

// Convert a big-endian base62-encoded String e to a BigInt.
function base62ToBigInt(e) {
    const base = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    const _62 = JSBI.BigInt(62);
    let n = JSBI.BigInt(0);
    for (let i = 0; i < e.length; i++) {
        const j = base.indexOf(e[i]);
        if (j === -1) {
            throw new Error("bad encoding");
        }
        n = JSBI.add(JSBI.multiply(n, _62), JSBI.BigInt(j));
    }
    return n;
}

// Convert a BigInt to a big-endian Uint8Array.
function bigIntToUint8Array(n, size) {
    const _256 = JSBI.BigInt(256);
    const b = new Uint8Array(size);
    for (let i = size - 1; i >= 0; i--) {
        b[i] = JSBI.toNumber(JSBI.remainder(n, _256));
        n = JSBI.divide(n, _256);
    }
    return b;
}

export function decodeBase62(e) {
    const n = base62ToBigInt(e);
    const a = bigIntToUint8Array(n, Math.ceil(e.length * Math.log2(62) / 8));
    const s = new TextDecoder().decode(a.buffer);
    return parseInt(s.replace(/\0/g, ''), 10);
}
